module.exports = __webpack_public_path__ + "img/APP_logo.36e6b1ce.jpg";